import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import "./LogVisitorModal.css";

import { DateTimePicker, LocalizationProvider } from "@mui/lab";
import { Autocomplete, Avatar, TextField } from "@mui/material";
import { stringAvatar } from "../../../../helpers/stringAvatar";
import { MultipleQueryTypesense } from "../../../../Typesense";
import { getLocalStorageItem } from "../../../../controllers/localStorage/getLocalStorage";
import { Timestamp } from "firebase/firestore";
import Select from "react-select";

const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: "400px",
  bgcolor: "#fff",
  border: 0,
  outline: "none",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  minHeight: "60vh",
};

const LogVisitorModal = (props) => {
  const {
    modalStatus,
    setModalStatus,
    visits,
    setVisits,
    singleVisit,
    setSingleVisit,
    myIndex,
    addOrUpdateVisits,
    selectedClient,
  } = props;

  const [client, setClient] = useState(null);
  const [localClients, setLocalClients] = useState([]);
  const [inputSearch, setInputSearch] = useState("");

  const [status, setStatus] = useState("interested");

  const [visitTime, setVisitTime] = useState(new Date());

  const [Vcomment, setVcomment] = useState("");

  const [error, setError] = useState("");

  //this side is used for dearching clients
  useEffect(() => {
    async function fetchPropertiesTypsenseWithSearch() {
      let leads = (
        await MultipleQueryTypesense({
          searches: [
            {
              collection: "leads",
              q: inputSearch,
              page: 1,
              per_page: 10,
              query_by: "name",
              filter_by: `is_deleted:=false && bid:=${getLocalStorageItem(
                "bid"
              )}`,
            },
          ],
        })
      ).map(({ document }) => document);
      setLocalClients([...leads]);
    }

    fetchPropertiesTypsenseWithSearch();
  }, [inputSearch]);

  console.log("localClients", localClients);

  useEffect(() => {
    if (modalStatus !== "update") {
      setClient(selectedClient);
      setVisitTime(new Date());
    }
  }, []);
  //this side effect is used to add values when the modal in opened in update state
  useEffect(() => {
    if (modalStatus == "update") {
      const initialValues = {
        client: singleVisit !== null ? singleVisit.client : selectedClient,
        status: singleVisit !== null ? singleVisit.status : "statused",

        visitTime:
          singleVisit !== null ? singleVisit.visitTime.toDate() : new Date(),
        comment: singleVisit !== null ? singleVisit.comment : "",
      };
      setClient(initialValues.client);
      setStatus(initialValues.status);
      setVisitTime(initialValues.visitTime);
      setVcomment(initialValues.comment);
    } else {
      console.log("Landbook App Else condition LogVisitorModal");
      setClient(selectedClient);
      setVisitTime(new Date());
    }

    return () => {
      setError("");
    };
  }, [singleVisit, modalStatus]);

  const handleClose = () => {
    setClient(null);
    setStatus("interested");

    setVisitTime(null);
    setVcomment("");
    setModalStatus("");
    setSingleVisit(null);
  };

  const handleSubmit = async () => {
    if (client === null) {
      setError("select a client");
      return;
    }
    let temp = visits;
    if (myIndex !== -1) {
      let getDate = Timestamp.fromDate(visitTime);

      temp[myIndex] = {
        client,
        status,
        visitTime: getDate,
        comment: Vcomment,
        added: singleVisit.added,
      };
      setVisits(temp);
    } else {
      let getDate = Timestamp.fromDate(visitTime);
      temp.push({
        client,
        status,
        visitTime: getDate,
        comment: Vcomment,
        added: new Date(),
      });
      setVisits(temp);
    }
    handleClose();
    await setTimeout(1000);
    addOrUpdateVisits();
  };

  return (
    <Modal
      open={modalStatus === "" ? false : true}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="Custom-Modal-Box" sx={style}>
        <div className="Log-visitor-model">
          <div className="Log-visitor-model-header">
            <p className="modal-heading">Log Visitors</p>
            <div className="modal-close-icon" onClick={handleClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="currentColor"
                class="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </div>
          </div>
          <hr className="mb-4" />

          <div className="transaction-inputs">
            <div
              className="client-input"
              style={{
                width: "75%",
              }}
            >
              <label className="form-field-label" htmlFor="text">
                Client
              </label>

              {/* <Select
                options={localClients}
                isClearable={true}
                isSearchable={true}
              /> */}
              <Autocomplete
                disablePortal
                // open={open}
                // onOpen={() => setOpen(true)}
                // onClose={() => setOpen(false)}
                variant="outlined"
                id="combo-box-demo"
                options={localClients}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, value, reason, details) => {
                  setClient(value);

                  // if (!client) {
                  //   handleClose();
                  // }
                }}
                getOptionLabel={(option) => option.name ?? ""}
                // sx={{ width: 300 }}
                defaultValue={!client ? null : client}
                onInputChange={(e, newInputValue) => {
                  setInputSearch(newInputValue);
                }}
                inputValue={inputSearch ?? ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // label="Select a client"
                    hiddenLabel
                    value={inputSearch ?? ""}
                  />
                )}
                renderOption={(props, option) => {
                  return (
                    <Box
                      style={{
                        display: "flex",
                      }}
                      {...props}
                    >
                      <div className="add-deal-client-dropdown">
                        <Avatar
                          className="add-deal-client-dropdown-avatar"
                          {...stringAvatar(option.name)}
                        />
                      </div>

                      <div className="client-modal-sub-container">
                        <p className="client-name">{option?.name}</p>
                        <p className="client-email">{option?.email}</p>
                        <p className="client-contact">{option?.phone}</p>
                      </div>
                    </Box>
                  );
                }}
              />
            </div>
            <div className="status-input">
              <label className="form-field-label" htmlFor="text">
                Status
              </label>
              <Select
                options={[
                  { value: "interested", label: "Interested" },
                  { value: "not-interested", label: "Not Interested" },
                ]}
                // value={paymentType}
                defaultValue={status}
                onChange={(e) => {
                  setStatus(e.value);
                }}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    border: "0px",
                    background: "var(--theme-color-light)",
                    outline: "none",
                    boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
                    width: "200px",
                    padding: "7px 0px 7px 0px",
                  }),
                }}
              />
            </div>
          </div>

          <div className="date-input mt-1">
            <label className="form-field-label" htmlFor="date">
              Visit Time
            </label>
            {/* <input
              className="input-style"
              type="datetime-local"
              value={visitTime}
              onChange={(e) => {
                setAdded(e.target.value);
              }}
            /> */}
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker
                value={visitTime}
                onChange={(val) => setVisitTime(val)}
                className="form-input-field"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    style={{
                      width: "100%",
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </div>

          <div className="interest-comments">
            <label className="form-field-label" htmlFor="comments">
              Description
            </label>
            <textarea
              className="form-input-field "
              name="comments"
              rows="10"
              cols="39"
              value={Vcomment}
              onChange={(e) => {
                setVcomment(e.target.value);
              }}
            />
          </div>
        </div>

        <Box className="add-deal-btn-container">
          <button
            className="close-modal-btn"
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </button>
          <button className="form-submit-button" onClick={handleSubmit}>
            Save
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default LogVisitorModal;

// <div className="form-row">
// <div className="form-group col-12">
//   <label className="myLbl">
//     Date
//   </label>

// </div>
// <p>
//   {/* {DateTimeError} */}
// </p>
// </div>
